export default "__VITE_ASSET__142eec2f__"